import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext({ user: null, isLoading: true, refresh: () => {}, logout: async () => {} });

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [isLoading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    const logout = useCallback(async () => {
        try { await api.post("/auth/logout"); } catch {}
        setUser(null);
    }, []);

    useEffect(() => {
        // Only probe /auth/me on admin routes — avoids a background 401 on every public page load.
        if (typeof window !== "undefined" && !window.location.pathname.startsWith("/admin")) {
            setLoading(false);
            return;
        }
        refresh();
    }, [refresh]);

    return (
        <AuthContext.Provider value={{ user, isLoading, refresh, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() { return useContext(AuthContext); }
